import React from 'react';

export default function useSnackbar() {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [type, setType] = React.useState("");
    
    React.useEffect(() => {
        if (open === true) {
            setTimeout(() => {
                setOpen(false);
            }, 3000);
        }
    }, [open]);

    const openSnackBar = (msg = 'Something went wrong...',type="success") => {
        setMessage(msg)
        setOpen(true);
        setType(type)
    }

    return { open, message, openSnackBar, type }
}